import { App } from "vue"
import { library } from "@fortawesome/fontawesome-svg-core"
import {
    faDroplet,
    faTemperatureHalf,
    faFire,
    faPipeValve,
    faSensorCloud,
    faFireFlameCurved,
    faClipboard,
    faCircleExclamation,
    faHeat,
    faPlug,
    faSensor,
    faThumbsDown,
    faThumbsUp,
    faBolt,
    faCircle1,
    faCircle2,
    faCircle3,
    faCircle4,
    faWifi,
    faWifiFair,
    faWifiSlash,
    faChartNetwork,
    faExclamationTriangle,
    faBatterySlash,
    faLocationDotSlash,
    faFireFlameSimple,
    faCloudSun,
} from "@fortawesome/pro-light-svg-icons"
import {
    faCircleQuestion,
    faEllipsis,
    faSensorTriangleExclamation,
    faThumbsUp as faThumbsUpSolid,
    faThumbsDown as faThumbsDownSolid,
} from "@fortawesome/pro-regular-svg-icons"
import {
    faAxe,
    faBattery,
    faBolt as faBoltSolid,
    faBug,
    faCircle,
    faCircleBolt,
    faDewpoint,
    faEuroSign,
    faFaucetDrip,
    faFireFlameSimple as faFireFlameSimpleSolid,
    faFireplace,
    faGripDots,
    faHandshake,
    faHeartRate,
    faHumidity,
    faLightbulb,
    faOilTemp,
    faOilTemperature,
    faSensorSmoke,
    faShower,
    faSignal,
    faSmog,
    faSolarPanel,
    faSunCloud,
    faTemperatureList,
    faThermometerHalf,
    faWaterLower,
    faWaterRise,
} from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"

/** Bound `library.add` so `this` stays correct (detached refs break Font Awesome internals). */
const addIcons = library.add.bind(library) as (...icons: unknown[]) => void

addIcons(
    faDroplet,
    faTemperatureHalf,
    faFire,
    faPipeValve,
    faSensorCloud,
    faFireFlameCurved,
    faClipboard,
    faCircleExclamation,
    faHeat,
    faPlug,
    faCircleQuestion,
    faEllipsis,
    faSensorTriangleExclamation,
    faThumbsDown,
    faThumbsUp,
    faThumbsUpSolid,
    faThumbsDownSolid,
    faBolt,
    faCircle1,
    faCircle2,
    faCircle3,
    faCircle4,
    faSensor,
    faWifi,
    faWifiSlash,
    faChartNetwork,
    faBug,
    faFireFlameSimple,
    faFireFlameSimpleSolid,
    faBatterySlash,
    faLocationDotSlash,
    faHandshake,
    faLightbulb,
    faExclamationTriangle,
    faWifiFair,
    faBoltSolid
)
addIcons(
    faAxe,
    faBattery,
    faCircle,
    faCircleBolt,
    faDewpoint,
    faEuroSign,
    faFaucetDrip,
    faFireplace,
    faGripDots,
    faHeartRate,
    faHumidity,
    faOilTemp,
    faOilTemperature,
    faSensorSmoke,
    faShower,
    faSignal,
    faSmog,
    faSolarPanel,
    faSunCloud,
    faTemperatureList,
    faThermometerHalf,
    faWaterLower,
    faWaterRise,
    faCloudSun
)

export default {
    install: (app: App) => {
        app.component("FontAwesomeIcon", FontAwesomeIcon)
    },
}
